var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm-tree"},[_c('div',{staticClass:"fm-tree-disk sticky-top",style:('z-index: 0;')},[_c('i',{staticClass:"bi bi-hdd"}),_vm._v(" "+_vm._s(_vm.selectedDisk)+" ")]),_c('branch',{attrs:{"parent-id":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }